module.exports = __webpack_public_path__ + "img/instruction-mobile.dbebff9a.gif";